<!--控制台饼状图组件-->
<!--author:yf-->
<template>
  <div style="position:relative;width: 100%;height: 100%;">
    <div style="width:100%;height:100%;" :id="id"></div>
    <div v-if="chartData.length===0" class="common-noData">暂无数据</div>
  </div>
</template>
<script>
  let echarts = require('echarts/lib/echarts'); // 引入基本模板
  require('echarts/lib/chart/pie');
  require('echarts/lib/component/tooltip');
  // require('echarts/lib/component/dataZoom');
  // require('echarts/lib/component/legend');
  require('echarts/lib/component/title')

  const merge = require('webpack-merge');

  export default {
    name: 'Chart',
    data() {
      return {
        myChart: '',
      };
    },
    props: {
      id: { // 分配渲染的盒子id
        type: String,
        default: 'ChartBox',
      },
      chartData: { // 渲染的节点数据及节点颜色
        type: Object,
        default() {
          return {
            title:'测试数据',
            data:[
              {value: 1, name: '未签署', itemStyle: {color: 'rgba(255, 132, 120, 1)'}},
              {value: 2, name: '已完成', itemStyle: {color: 'rgba(120, 214, 255, 1)'}},
              {value: 3, name: '已失效', itemStyle: {color: 'rgba(120, 179, 255, 1)'}},
              {value: 4, name: '其他', itemStyle: {color: 'rgba(252, 178, 112, 1)'}},
            ]
          }
        }
      },
      option: {
        type: Object,
        default: function () {
          return {};
        },
      },
    },
    mounted() {
      this.myChart = echarts.init(document.getElementById(this.id));
      this.showLoading(); // 数据获取显示之前先加载一段动画
      this.draw();
    },
    methods: {
      // 使用说明：
      // 无数据时显坐标轴并显示无数据
      getOption() {
        let defaultOption = {
          title: {text: this.chartData.title, x: 'center', y: 'center', textStyle: {color: 'rgba(41, 2, 2, 1)', fontSize: 14}},
          tooltip: {
            backgroundColor: 'rgba(50,50,50,0.4)',
            trigger: 'item',
            // formatter: '{b} : {c} ({d}%)'
            formatter(param) {
              // console.log(param)
              return param.marker + param.name + ': ' + param.value
            }
          },
          // legend: {x: 'center', y: 'bottom', data: ['未签署', '已完成', '其他']},
          calculable: true,
          series: [
            {
              name: '签署状态分布',
              type: 'pie',
              radius: [55, 90],
              center: ['50%', '50%'],
              label: {
                normal: {
                  fontSize: 12,
                  show: true,
                  formatter: '{b}：{d}%'
                },
                emphasis: {show: true}
              },
              lableLine: {normal: {show: false}, emphasis: {show: true}},
              data: this.chartData.data
            }],
        }
        if (Object.keys(this.option).length) {
          defaultOption = merge(defaultOption, this.option);
        }
        return defaultOption;
      },
      draw() { // 绘制图表
        this.hideLoading();
        this.myChart.clear();
        this.resetChartData();
      },
      resetChartData() { // 刷新数据
        this.myChart.setOption(this.getOption(), true);
        this.hideLoading();
      },
      showLoading() { // 显示加载动画
        this.myChart.showLoading();
      },
      hideLoading() { // 关闭加载动画
        this.myChart.hideLoading();
      },
    },
    watch: {
      chartData:{
        handler(n,o){
          this.resetChartData();
        },
        // immediate: true,  //刷新加载 立马触发一次handler
        deep: true  // 可以深度检测到 person 对象的属性值的变化
      }
    },
    beforeDestroy() {
      this.myChart && this.myChart.dispose();
    },
  }
</script>
<style scoped>
  .common-noData {
    color: #ffffff;
    text-align: center;
    position: absolute;
    width: 100%;
    left: 0;
    top: 50%;
    margin-top: -10px;
  }
</style>




// WEBPACK FOOTER //
// components/charts/console-pie.vue